import { h } from 'preact';
import { useState } from 'preact/hooks';
import { Button, Modal, Form } from 'react-bootstrap';
import DocumentUploadModal from "../document-upload-modal";
import FileUploader from "../file-uploader";

const TicketSaveModal = ({ show, handleClose, ticket, onSave }) => {
    // Initial form state setup
    const [formData, setFormData] = useState({
        title: ticket?.title || '',
        description: ticket?.description || '',
        status: ticket?.status || '',
        priority: ticket?.priority || '',
        category_id: ticket?.category_id || '',
        user_id: ticket?.user_id || '',
        assigned_to: ticket?.assigned_to || '',
        created_by: ticket?.created_by || '',
        updated_by: ticket?.updated_by || '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{ticket ? 'Modifier un ticket' : 'Créer un ticket'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit} id="save-ticket-form">
                    {/* Form fields for each ticket attribute */}
                    <Form.Group className="mb-3">
                        <Form.Label>Title</Form.Label>
                        <Form.Control type="text" name="title" value={formData.title} onChange={handleChange} required />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control as="textarea" name="description" value={formData.description} onChange={handleChange} required />
                    </Form.Group>

                    <FileUploader />
                    {/* Additional fields for status, priority, etc. should be added here */}

                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" type="submit" form={'save-ticket-form'}>
                    Enregistrer
                </Button>
                <Button variant="secondary" onClick={handleClose}>Fermer</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TicketSaveModal;
